import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <Link to="/about" className="footer-link">About</Link>
      </div>
    </footer>
  );
};

export default Footer; 